'use client'

import { FloatingArrow } from '@floating-ui/react'
import React, { FC } from 'react'

import { useTooltipContext } from './tooltip'
import { cn } from '../../utils/cn'

interface TooltipArrowProps {
  className?: string
}

export const TooltipArrow: FC<TooltipArrowProps> = ({ className }) => {
  const { arrowRef, context } = useTooltipContext()
  return (
    <FloatingArrow
      ref={arrowRef}
      context={context}
      className={cn('fill-slate-800', className)}
    />
  )
}
